import https from "./https"
import store from "@/store"

const partnerMarketingPlanSerial = {
  getCodes(planId, params) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/${planId}/codes`, {params})
  },
  
  exportCodes(planId, params) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/${planId}/codes/export`, {params})
  },
  
  uploadCodes(planId, formData) {
    const organization = store.state.general.organization
    return https.post(`admin/organizations/${organization.id}/partner-marketing-plans/${planId}/codes/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  
  getCodeStats(planId) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/partner-marketing-plans/${planId}/codes/stats`)
  },
  
  deleteCodes(planId, params) {
    const organization = store.state.general.organization
    return https.delete(`admin/organizations/${organization.id}/partner-marketing-plans/${planId}/codes`, {
      data: params
    })
  },

  toggleStatus(planId, codeId) {
    const organization = store.state.general.organization
    return https.patch(`admin/organizations/${organization.id}/partner-marketing-plans/${planId}/codes/${codeId}/toggle-status`)
  }
}

export default partnerMarketingPlanSerial